module.exports = __webpack_public_path__ + "img/game_003.71b7c6b6.png";